import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import dashIcon1 from "../../assets/images/dashboard-1.svg";
import ShoppingAPI from "../../store/shopping/shopping.api";
import { getUserProfile } from "../../store/user/user.selector";

const AllSpendings = () => {
    const [spendings, setSpendings] = useState([]);
    const [period, setPeriod] = useState("1");

    const { userProfile } = useSelector((state) => {
        return {
            userProfile: getUserProfile(state),
        };
    });

    useEffect(() => {
        ShoppingAPI.GetTransactions("?spentAll=true")
            .then((x) => {
                setSpendings(x.data);
            })
            .catch((x) => {
                setSpendings([]);
            });
    }, []);

    let filteredList = spendings;

    if (period === "1") {
        filteredList = spendings.filter((x) => {
            return (
                moment(x.dateCreated).format("MMYYYY") ===
                moment().format("MMYYYY")
            );
        });
    } else if (period === "-1") {
        filteredList = spendings.filter((x) => {
            return (
                moment(x.dateCreated).format("MMYYYY") ===
                moment().subtract(1, "month").format("MMYYYY")
            );
        });
    }

    return (
        <div className="p-2 sm:p-4 lg:px-8 lg:py-7 flex flex-col h-full overflow-y-auto">
            <div className="mb-1.5">
                <h2 className="text-xl font-bold text-ebony-color">
                    All Spendings
                </h2>
            </div>

            <div className="p-4 grid  grid-cols-12 bg-white gap-6 rounded-lg border border-black-10 h-[calc(100%_-_34px)]">
                <div className="col-span-12 md:col-span-7 lg:col-span-9 lg:border-r lg:border-black-10 lg:pr-7 overflow-y-auto">
                    <div className="m-px mb-5">
                        <select
                            name=""
                            id=""
                            value={period}
                            onChange={(e) => {
                                setPeriod(e.target.value);
                            }}
                            className="py-2.5 w-[175px] px-[13px] rounded-md ring-[1px] border-r-[10px] border-transparent ring-[#D1D5DB] outline-none text-sm text-black-60 capitalize"
                        >
                            <option
                                value={"1"}
                                className="border-none outline-none"
                            >
                                {" "}
                                this month
                            </option>
                            <option
                                value={"-1"}
                                className="border-none outline-none"
                            >
                                {" "}
                                Last month
                            </option>
                            <option
                                value={"0"}
                                className="border-none outline-none"
                            >
                                {""}
                                All Time
                            </option>
                        </select>
                    </div>

                    <div className="overflow-x-auto relative">
                        <table className="w-full text-left">
                            <thead className="text-sm font-medium text-black-50 capitalize border-b border-black-10 pb-2.5">
                                <tr>
                                    <th
                                        scope="col"
                                        className="py-2.5 whitespace-nowrap"
                                    >
                                        date
                                    </th>
                                    <th
                                        scope="col"
                                        className="py-2.5 whitespace-nowrap"
                                    >
                                        amount
                                    </th>
                                    <th
                                        scope="col"
                                        className="py-2.5 whitespace-nowrap"
                                    >
                                        type
                                    </th>
                                </tr>
                            </thead>
                            <tbody className="text-sm text-black-60">
                                {filteredList.map((spend) => (
                                    <tr
                                        key={spend._id}
                                        className="bg-white border-b border-black-10 capitalize "
                                    >
                                        <td className="py-[19px] whitespace-nowrap text-ebony-color">
                                            {moment(spend.dateCreated).format(
                                                "DD/MM/YYYY"
                                            )}
                                        </td>
                                        <td className="py-[19px] text-black-60 uppercase">
                                            myr {spend.totalAmount.toFixed(2)}
                                        </td>
                                        <td className="py-[19px] text-black-80">
                                            {spend.type}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        {filteredList.length === 0 && (
                            <div className="flex flex-col items-center justify-center md:py-24 lg:py-32">
                                <p className="mb-2 text-xl sm:text-2xl font-bold text-center text-gray-800 md:text-3xl">
                                    <span className="text-red-500">Oops!</span>{" "}
                                    No result found :(
                                </p>
                            </div>
                        )}
                    </div>
                </div>
                <div className="col-span-12 md:col-span-5 lg:col-span-3">
                    <div className="grid grid-cols-1 gap-y-3 mb-4">
                        <div className="p-4 bg-white rounded-lg border border-black-10">
                            <div className="flex items-center justify-between">
                                <div className=" capitalize">
                                    <h4 className="text-sm font-medium text-black-50 mb-1.5">
                                        This Month
                                    </h4>
                                    <p className="text-xl font-bold text-ebony-color">
                                        {userProfile.country.currency}{" "}
                                        {spendings
                                            .filter((x) => {
                                                return (
                                                    moment(
                                                        x.dateCreated
                                                    ).format("MMYYYY") ===
                                                    moment().format("MMYYYY")
                                                );
                                            })
                                            .map((x) => x.totalAmount)
                                            .reduce(
                                                (partialSum, a) =>
                                                    partialSum + a,
                                                0
                                            )
                                            .toFixed(2)}
                                    </p>
                                </div>
                                <img src={dashIcon1} alt="" />
                            </div>
                        </div>
                        <div className="p-4 bg-white rounded-lg border border-black-10">
                            <div className="flex items-center justify-between">
                                <div className=" capitalize">
                                    <h4 className="text-sm font-medium text-black-50 mb-1.5">
                                        All Spendings
                                    </h4>
                                    <p className="text-xl font-bold text-ebony-color">
                                        {userProfile.country.currency}{" "}
                                        {spendings
                                            .map((x) => x.totalAmount)
                                            .reduce(
                                                (partialSum, a) =>
                                                    partialSum + a,
                                                0
                                            )
                                            .toFixed(2)}
                                    </p>
                                </div>
                                <img src={dashIcon1} alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AllSpendings;
